function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { Input as BaseInput } from "./input";
import { ErrorMessage, Label } from "../shared";
import { Addon } from "./addon";
import { forwardRef } from "react";
import { jsx as ___EmotionJSX } from "@emotion/core";
export { InputWithButton } from "./withbutton";
export { TextArea } from "./textarea";
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13nge2u-Input",
  styles: "grid-area:label;;label:Input;"
} : {
  name: "13nge2u-Input",
  styles: "grid-area:label;;label:Input;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var Input = forwardRef(function (_ref, ref) {
  var errorMessage = _ref.errorMessage,
    label = _ref.label,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onEnterPress = _ref.onEnterPress,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    value = _ref.value,
    placeholder = _ref.placeholder,
    id = _ref.id,
    name = _ref.name,
    disabled = _ref.disabled,
    type = _ref.type,
    autoFocus = _ref.autoFocus;
  var isValid = !errorMessage;
  return ___EmotionJSX(Label, {
    "data-bpl": true,
    hasPrefix: !!prefix,
    hasSuffix: !!suffix,
    hasLabel: !!label,
    hasError: !!errorMessage
  }, label && ___EmotionJSX("span", {
    css: _ref2
  }, label), prefix && ___EmotionJSX(Addon, {
    "data-bpl": true,
    type: "prefix",
    size: size
  }, prefix), ___EmotionJSX(BaseInput, {
    "data-bpl": true,
    errorMessage: errorMessage,
    prefix: prefix,
    suffix: suffix,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onEnterPress: onEnterPress,
    size: size,
    value: value,
    placeholder: placeholder,
    id: id,
    name: name,
    disabled: disabled,
    type: type,
    autoFocus: autoFocus,
    ref: ref
  }), suffix && ___EmotionJSX(Addon, {
    type: "suffix",
    size: size
  }, suffix), !isValid && ___EmotionJSX(ErrorMessage, null, errorMessage));
});